module.exports = __webpack_public_path__ + "static/media/autotone_before.75d23bf4.png";